import { TabStyles } from '@tableau/widgets';
import { DataGrid } from '@tableau/widgets-datagrid';

import { Messages } from '~src/codegen/Localize';
import { PlainTextCell } from '~src/spacesPlatform/components/ListView/dataGridCells/PlainTextAndNumberCells';
import { PlainTextHeader } from '~src/spacesPlatform/components/ListView/dataGridCells/PlainTextHeader';

export interface FlowParametersGridRow {
  parameterName: string;
  parameterValue: string;
  parameterDescription: string;
}

const styleOverride = {
  paddingLeft: 0,
};
const headerStyle = {
  fontSize: TabStyles.Typography.Sizing.Default,
  fontWeight: 500
};

export function flowParametersColumns(): DataGrid.Column[] {
 return [{
      name: 'flow-parameter-name',
      dataKey: 'parameterName',
      sortable: true,
      headerText: Messages.name(),
      headerFormatter: PlainTextHeader(headerStyle),
      resizable: false,
      cellFormatter: PlainTextCell('parameterName', 'parameterNameCell', styleOverride)
    }, {
      name: 'flow-parameter-value',
      dataKey: 'parameterValue',
      sortable: true,
      headerText: Messages.flowParametersParameterValue(),
      headerFormatter: PlainTextHeader(headerStyle),
      resizable: false,
      cellFormatter: PlainTextCell('parameterValue', 'parameterValueCell', styleOverride)
    }, {
      name: 'flow-parameter-description',
      dataKey: 'parameterDescription',
      sortable: false,
      headerText: Messages.flowParametersDescription(),
      headerFormatter: PlainTextHeader(headerStyle),
      resizable: false,
      cellFormatter: PlainTextCell('parameterDescription', 'parameterDescriptionCell', styleOverride),
      growToFit: true,
    }
  ];
}
